import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { Subject, forkJoin, map, takeUntil} from 'rxjs';
import { SidebarMenuComponent } from '../sidebar-menu/sidebar-menu.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { MenuModuleCourseComponent } from '../menu-module-course/menu-module-course.component';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { CoursesService } from 'src/app/services/courses.service';
import { ContentService } from 'src/app/services/content.service';
import { DataCourse, File } from 'src/app/shared/interfaces/course.interface';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderComponent } from '../loader/loader.component';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    RouterOutlet,
    CommonModule,
    SidebarMenuComponent,
    NavbarComponent,
    MenuModuleCourseComponent,
    LoaderComponent,
  ],
})

export class DashboardComponent {
  isExpanded = true;
  isLoading: boolean = true;
  courses: DataCourse[] = [];
  activitiesWithCourse: any[] = [];
  progress: number[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private localStorage: LocalstorageService,
    private coursesService: CoursesService,
    private contentService: ContentService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    try {
      const studentStorage = this.localStorage.getItem('current_user_edutegia');
      let studentData: any = null;

      (studentStorage) ? studentData = JSON.parse(studentStorage) : console.error('No se encontró el usuario');

      const studentId: number = studentData ? studentData.uid : '';

      this.coursesService.getCoursesWithInfo(studentId).subscribe({
        next: (courses: DataCourse[]) => {
          console.log(courses);
          this.getActivitiesOfCourses(courses);
        },
        error: (error: any) => {
          this.isLoading = false;
          this.contentService.bool$.next(true);
          if (error === 'Debes volver a iniciar sesión') {
            this.handleLogout();
          } else {
            console.error('Error: trayendo los cursos', error);
          }
        }
      });
      this.setUserImage();
      this.contentService.executeInLearningZone$.next(true);
    } catch (error) {
      console.error('Error al inicializar:', error);
    }
  }

  private handleLogout(): void {
    const logoutToken = localStorage.getItem('logout_token_edutegia');
    const globalToken = localStorage.getItem('global_token_edutegia');

    this.authService.logoutWithCookie(logoutToken, globalToken).subscribe((resp: any) => {
      // console.log('logout');
      if (resp === null) {
        this.router.navigate(['/login']);
      }
    });
  }

  getActivitiesOfCourses(courses: DataCourse[]) {
    console.log(courses);
    const activitiesObservable = courses.map(course => {
      const courseId = course['id'];
      const activitiesObservable = this.contentService.getActivitiesByCourseId(courseId).pipe(
        map(activities => activities.filter(activity => activity.attributes.status === true))
      );

      return forkJoin([activitiesObservable]).pipe(
        map(([activities]) => {
          console.log(activities);
          return {
            title: course.attributes.title,
            path: course.attributes.path.alias,
            activities
          };
        })
      );
    });

    if(activitiesObservable.length === 0) {
      this.isLoading = false;
      this.contentService.bool$.next(true);
    }
    forkJoin(activitiesObservable).pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: results => {
          this.contentService.setActivities(results);
          this.isLoading = false;
        },
        error: error => {
          console.error('Error en el observable de cursos con actividades', error)
          this.isLoading = false;
          this.contentService.bool$.next(true);
        }
      }
    );
  }

  setUserImage(){
    const user = this.localStorage.getCurrentUserProfileAsJson();
    if (user.relationships.user_picture?.data) {
      const idImgUser = user.relationships.user_picture.data.id;
      this.contentService.getFileContent(idImgUser).pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (imgUser: File) => {
            this.localStorage.setItem('userImg', imgUser.url);
          },
          error: error => {
            console.error('Error: trayendo la imagen del usuario', error);
          }
        }
      );
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
